import { UserDto } from '@tallo/user';

import { ConversationTraceDto } from './conversation-trace.interface';
import { MessageFeedbackDto } from './message-feedback.interface';
import { MessageType } from './message-type.enum';

export enum CommunicationChannel {
  EMAIL = 'Email',
  SMS = 'SMS',
}

export interface MessageDto {
  id: number;
  user: UserDto | null;
  type: MessageType;
  content: string;
  isSystem: boolean;
  isDistributed: boolean;
  isSeen: boolean;
  createdAt: string;
  updatedAt: string;
  communicationChannel?: CommunicationChannel;
  // The viewing landlord's own feedback on this message. Only populated on investor transcript
  // endpoints; undefined elsewhere, in which case the feedback bar simply starts unrated.
  feedback?: MessageFeedbackDto | null;
  // Conversation traces decorating this message — the engine moments of the turn that produced it,
  // synthesized into one context chip. Investor transcript endpoints only, like feedback.
  traces?: ConversationTraceDto[];
}
